const firebaseConfig = {
    apiKey: "AIzaSyAqa6Q3WQ7_4jdT59MbSrYiwyUGJCW_Mas",
    authDomain: "kafilatoly-general-hospital.firebaseapp.com",
    projectId: "kafilatoly-general-hospital",
    storageBucket: "kafilatoly-general-hospital.appspot.com",
    messagingSenderId: "42653498566",
    appId: "1:42653498566:web:8f1ebf333242972a4c6bc7",
    measurementId: "G-T16FSY2SC2"
};

export default firebaseConfig;